import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ProfileTitle from '../../../../layout/mobile/profile/ProfileTitle';
import PasswordIcon from '../../../../common/icons/passwordIcon';
import { useSelector, useDispatch } from 'react-redux';
import { updateUserPassword } from '../../../../../redux/actions/PasswordActions';
import { schema } from './validation/schema';
import { errorMessage } from '../../../../../redux/actions/FlashActions';
import FormContainer from '../common/FormContainer';
import Title from '../common/Title';
import Subtitle from '../common/Subtitle';
import Buttons from '../common/Buttons';
import Password from './Password';

const PasswordForm = ({ ...props }) => {
  const { mobile } = props;
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.passwordReducer.loading);
  const error = useSelector((state) => state.passwordReducer.error);
  const [formState, setFormState] = useState('');
  const [internalValidation, setInternalValidation] = useState(false);
  const handleSendClick = () => {
    if (
      'error' in
        schema.validate({
          password: formState.password,
          confirmationPassword: formState.confirmationPassword,
        }) ||
      formState.password !== formState.confirmationPassword
    ) {
      setInternalValidation(true);
      dispatch(
        errorMessage(
          'Debes completar todos los campos antes de enviar el formulario',
        ),
      );
    } else {
      setInternalValidation(false);
      dispatch(
        updateUserPassword({
          newPassword: formState.password,
          newConfirmationPassword: formState.confirmationPassword,
          oldPassword: formState.oldPassword,
        }),
      );
    }
  };
  const handleFocus = (formState) => {
    setFormState(formState);
  };
  return (
    <React.Fragment>
      <ProfileTitle
        mobile={mobile}
        title="Contraseña"
        subtitle="Si quieres modificar tu contraseña, asegúrate que esta sea segura."
        icon={<PasswordIcon size="30px" color="#6A148E" />}
      />
      <FormContainer>
        <Title shouldModify={true} title="Modificar contraseña" />
        <Subtitle subtitle="Aqui encontrarás tu contraseña. Si la quieres modificar asegúrate de que sea segura." />
        <Password
          onFocus={handleFocus}
          internalValidation={internalValidation}
        />
        <Buttons
          loading={loading}
          error={error}
          onSendClick={handleSendClick}
          mobile={mobile}
          primaryButtonText={'Cambiar contraseña'}
        />
      </FormContainer>
    </React.Fragment>
  );
};

PasswordForm.propTypes = {
  mobile: PropTypes.bool,
};

export default PasswordForm;
